import ACTIONS from './types';

export default function reducers(
  state = {
    data: {},
    loading: false,
    error: null,
    qnaModalOpen: false,
    qnaAskedToId: null,
    questions: [],
    userDetails: {},
    showMissingDetailsModal: false,
    quickFilters: [],
    advancedFilters: {},
    search: null,
    successModalOpen: false,
    paidUser: false,
    setCompleted: false,
    crtCompleted: false,
    menteeId: null,
    isShareable: false,
    product: '',
    isFcRegistered: false,
    isFcRegisteredAlready: false,
    isFcRegistering: false,
    isFcModalOpen: false,
    fcEventData: {},
    fcEventDataError: false,
    isPersonalisationModalOpen: false,
    isProfileSidebarModalOpen: false,
    isSignupSideBarOpen: false,
  },
  action,
) {
  switch (action.type) {
    case ACTIONS.SET_REQUEST_PARAMS:
      return {
        ...state,
        ...action.payload,
      };
    case ACTIONS.SET_USER_DETAILS:
      return {
        ...state,
        showMissingDetailsModal: action.payload.missingDetails,
        userDetails: action.payload.userDetails,
        successModalOpen: action.payload.successModalOpen,
      };
    case ACTIONS.SET_REVIEWS_INIT:
      return {
        ...state,
        loading: true,
        data: action.payload.reset ? {} : state.data,
      };
    case ACTIONS.SET_REVIEWS_COMPLETE:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case ACTIONS.SET_REVIEWS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
        data: {
          ...state.data,
          testimonials: [],
        },
      };
    case ACTIONS.SET_QUESTIONS_INIT:
      return {
        ...state,
      };
    case ACTIONS.SET_QUESTIONS_COMPLETE:
      return {
        ...state,
        questions: action.payload.questions,
        qnaModalOpen: action.payload.open,
        qnaAskedToId: action.payload.askedToId,
      };
    case ACTIONS.SET_QUESTIONS_ERROR:
      return {
        ...state,
        questions: [],
      };
    case ACTIONS.SET_INITIAL_RESOURCES_INIT:
      return {
        ...state,
      };
    case ACTIONS.SET_INITIAL_RESOURCES_COMPLETE:
      return {
        ...state,
        paidUser: action.payload.paidUser,
        setCompleted: action.payload.setCompleted,
        crtCompleted: action.payload.crtCompleted,
        menteeId: action.payload.menteeId,
        product: action.payload.product,
      };
    case ACTIONS.SET_INITIAL_RESOURCES_ERROR:
      return {
        ...state,
        paidUser: false,
        setCompleted: false,
        crtCompleted: false,
        menteeId: null,
      };
    case ACTIONS.SET_VERIFY_COMPLETE:
      return {
        ...state,
        qnaModalOpen: false,
        qnaAskedToId: null,
        questions: [],
      };
    case ACTIONS.OPEN_QNA_MODAL:
      return {
        ...state,
        qnaModalOpen: true,
        qnaAskedToId: action.payload,
      };
    case ACTIONS.CLOSE_QNA_MODAL:
      return {
        ...state,
        qnaModalOpen: false,
      };
    case ACTIONS.TOGGLE_SUCCESS_MODAL:
      return {
        ...state,
        successModalOpen: !state.successModalOpen,
      };
    case ACTIONS.TOGGLE_MISSING_DETAILS:
      return {
        ...state,
        showMissingDetailsModal: !state.showMissingDetailsModal,
      };
    case ACTIONS.TOGGLE_SHARE_STATE:
      return {
        ...state,
        isShareable: false,
      };
    case ACTIONS.FC_MODAL_OPEN:
      return {
        ...state,
        isFcModalOpen: true,
      };
    case ACTIONS.FC_MODAL_CLOSE:
      return {
        ...state,
        isFcModalOpen: false,
      };
    case ACTIONS.SET_FC_REGISTERED:
      return {
        ...state,
        isFcRegistered: true,
        isFcRegistering: false,
      };
    case ACTIONS.SET_FC_REGISTERED_ALREADY:
      return {
        ...state,
        isFcRegisteredAlready: true,
      };
    case ACTIONS.SET_FC_REGISTERING:
      return {
        ...state,
        isFcRegistering: true,
      };
    case ACTIONS.SET_UPCOMING_LIVE_CLASS:
      return {
        ...state,
        fcEventData: action.payload,
      };
    case ACTIONS.SET_UPCOMING_LIVE_CLASS_ERROR:
      return {
        ...state,
        fcEventDataError: true,
      };
    case ACTIONS.SET_PERSONALISATION_MODAL_OPEN:
      return {
        ...state,
        isPersonalisationModalOpen: action.payload,
      };
    case ACTIONS.SET_PROFILE_SIDEBAR:
      return {
        ...state,
        isProfileSidebarModalOpen: action.payload,
      };
    case ACTIONS.SET_SIGNUP_SIDEBAR:
      return {
        ...state,
        isSignupSideBarOpen: action.payload,
      };
    default:
      return state;
  }
}
